import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "article-feed-by-newsletter__column"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id"]
const _hoisted_4 = {
  key: 0,
  class: "image pb-xs-2"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "entry-postdate" }
const _hoisted_7 = { class: "postDate" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["id"]
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  class: "newsletter-title pl-xs-1",
  "aria-label": "Click to view associated newsletter"
}
const _hoisted_12 = {
  key: 0,
  id: "latest-article-view-more-btn",
  "aria-label": "Click to expand/show additional articles"
}
const _hoisted_13 = {
  key: 1,
  id: "latest-article-view-less-btn",
  "aria-label": "Click to collapse/hide additional articles"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "Sorry, there was an error with the data. We are working to resolve this as quickly as possible.", -1)
const _hoisted_16 = [
  _hoisted_15
]

import { PropType, ref, computed } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

interface articleData {
  data: {
    entries: {
      id: string
      issueToArticles: {
        id: string
        postDate: string
        title: string
        url: string
        entryImage: {
          url: string
          title: string
        }[]
      }[]
      issueToNewsletter: { id: string; title: string; url: string }[]
    }[]
  }
}


const __default__ = { name: 'ArticleFeed' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  newsletterCount: {
    type: Number,
    default: 0,
    required: true,
  },
  articlenewsdata: {
    type: Object as PropType<articleData>,
    required: true,
  },
  issueids: {
    type: Array as PropType<string[]>,
    default: () => [],
    require: true,
  },
},
  setup(__props) {

const props = __props



// Reactive variable to control the number of displayed articles
const displayCount = ref(3)

//if there are more than 3 Newsletters/Issues selected - we're passing in the count
//only display 3 on page load
//use button to show/hide the remaining newsletters
// Toggle button method
const toggleButton = (articleCountChange: number) => {
  // Update the display count based on the button click
  // set the displayCount.value
  // if countChange variable is <= 3, then get the articlenewsdata length.  Else set value to 3.
  displayCount.value =
    articleCountChange <= 3 ? props.articlenewsdata.data.entries.length : 3
}

// This is taking the articlenewsdata object and changing the order of the data to match issueids
// issueids is in the same order as what is in the craftcms - we want to keep this order
// I'm doing this here b/c it was simpler than trying to reorder on the .twig/graphql side of things.

const sortedArticleData = computed(() => {
  // Convert issueids to strings to match the type of ids in articlenewsdata
  const orderedIds = props.issueids.map(id => id.toString())
  
  // Create a local variable to store a copy of entries without modifying the prop
  const entriesCopy = [...props.articlenewsdata.data.entries]
  
  // Sort entries based on the order of issueids
  const sortedEntries = entriesCopy.sort((a, b) => {
    return orderedIds.indexOf(a.id.toString()) - orderedIds.indexOf(b.id.toString())
  })
  return sortedEntries
})

return (_ctx: any,_cache: any) => {
  return (_unref(sortedArticleData)?.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedArticleData).slice(
        0,
        displayCount.value
      ), (article, index) => {
          return (_openBlock(), _createElementBlock("div", {
            id: `issue-${article.id}`,
            key: index,
            class: "article-feed-by-newsletter__articles divider pb-xs-3 mb-xs-3"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(article.issueToArticles, (details) => {
              return (_openBlock(), _createElementBlock("div", {
                id: `article-${details.id}`,
                key: details.id,
                class: "news-artciles-entries"
              }, [
                (details.entryImage[0])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("img", {
                        src: details.entryImage[0].url,
                        alt: ""
                      }, null, 8, _hoisted_5)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("small", _hoisted_7, _toDisplayString(details.postDate), 1)
                ]),
                _createElementVNode("a", {
                  href: details.url,
                  class: "article-title pt-xs-2 pb-xs-2",
                  "aria-label": "Click to read entire article"
                }, _toDisplayString(details.title), 9, _hoisted_8)
              ], 8, _hoisted_3))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(article.issueToNewsletter, (parent) => {
              return (_openBlock(), _createElementBlock("div", {
                id: `newsletter-${parent.id}`,
                key: parent.id,
                class: "newsletter"
              }, [
                _createElementVNode("a", {
                  href: parent.url
                }, [
                  _createVNode(_unref(FontAwesomeIcon), {
                    icon: ['far', 'newspaper'],
                    class: "newspaper-icon-size"
                  }),
                  _createElementVNode("small", null, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(parent.title), 1)
                  ])
                ], 8, _hoisted_10)
              ], 8, _hoisted_9))
            }), 128))
          ], 8, _hoisted_2))
        }), 128)),
        (_unref(sortedArticleData).length > 3)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-md btn--outline btn--primary pt-xs-2 pb-xs-2 pl-xs-3 pr-xs-3",
              onClick: _cache[0] || (_cache[0] = () => toggleButton(displayCount.value))
            }, [
              (displayCount.value <= 3)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, " View More Articles "))
                : (_openBlock(), _createElementBlock("span", _hoisted_13, " View Fewer Articles "))
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
}
}

})